/**
 * Разница двух значений одной формы, строками «путь: было → стало».
 *
 * Один помощник на два места: журнал изменений показывает им правку
 * конфига, а подтверждение возврата к файлу — то, что будет стёрто.
 * Разойдись эти два представления, и одно и то же изменение выглядело бы
 * в журнале не так, как в предупреждении о нём.
 */

export function diffLeaves(before: unknown, after: unknown, prefix: string[] = []): string[] {
  if (isPlain(before) && isPlain(after)) {
    const keys = new Set([...Object.keys(before), ...Object.keys(after)])
    return [...keys].flatMap((key) => diffLeaves(before[key], after[key], [...prefix, key]))
  }

  if (JSON.stringify(before) === JSON.stringify(after)) return []
  return [`${prefix.join('.') || 'value'}: ${JSON.stringify(before)} → ${JSON.stringify(after)}`]
}

export function isPlain(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
